<template>
  <div class="mobile-wrap">
    <!-- <div id="app"> -->
    <div >
      <div class="pic">
        <img v-if="!info.brand" src="../img/eilis.png" style="transform: scale(1); margin-left: 10px;" alt="louisa logo"  width="100%">
        <img v-if="info.brand === 'NAUTICA'" src="../img/Nautica.png" style="transform: scale(0.7); margin-top: -100px;" alt="louisa logo"  width="100%">
        <img v-if="info.brand === 'Whittard'" src="../img/whittard.jpg" style="transform: scale(0.5); margin-top: -100px; z-index: 1"   width="100%">
        <img v-if="info.brand === 'Eden Park'" src="../img/Eden-Park.png" style="transform: scale(1); position:fixed; margin-top: 0px; left: 0%; z-index: 1"   width="100%">
        <img v-if="info.brand === 'JEEP'" src="../img/JEEP.png" style="transform: scale(1); position:fixed; margin-top: 0px; left: 0%; z-index: 1" width="100%">
        <img v-if="info.brand === 'LIP SERVICE'" src="../img/LIP.jpg" style="transform: scale(0.6); position:fixed; margin-top: -90px; left: 0%; z-index: 1" width="100%">
        <!-- <section>
          <svg id="curve" data-name="圖層 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 616.67 440">
          <path class="cls-1" d="M604.78-8.44s-22.1,58-110.48,70.91c-71.58,10.44-333,22-371.61,191.8C84.53,421.89-11.89,431.56-11.89,431.56v-440Z" transform="translate(11.89 8.44)"/></svg>
        </section> -->
      </div>
      <br>
      <!-- Token -->
      <!-- <cube-textarea class="item" :placeholder="transform" disabled>
      </cube-textarea> -->

      <!-- 電話 -->
      <cube-input   class="item"  v-model="info.phone"  :placeholder="$t('Login.authHint') + countries.filter(el => el.value === countryCode).map(el => el.example)[0]" disabled>
      </cube-input>

      <!-- 輸入姓名 -->
      <!-- <cube-input   class="item"  v-model="name" placeholder="輸入姓名" ></cube-input> -->
      <cube-form :model="model">
        <cube-form-group>
          <cube-form-item class="item" style="border: 1px solid #eee; width: 72%" :field="fields[0]"></cube-form-item>
          <cube-form-item class="item" style="border: 1px solid #eee; width: 72%" :field="fields[1]"></cube-form-item>
          <cube-form-item class="item" style="border: 1px solid #eee; width: 72%" :field="fields[2]"></cube-form-item>
          <cube-form-item class="item" style="border: 1px solid #eee; width: 72%" :field="fields[3]"></cube-form-item>
        </cube-form-group>
      </cube-form>

      <br>
      <!-- <cube-button class="item"  :light="true" @click="login">確認</cube-button> -->
      <cube-button id="sign-in-button" class="item" :light="true"  style="transform: translateY(0px);" @click="openTerms" >隱私與使用者條款</cube-button>

      <cube-checkbox style="margin-left:110px; top:20px; font-size: 15px;" v-model="checked" position="center" shape="square" :hollow-style="true">
        <span style="letter-spacing: 3px;">我已閱讀並同意</span>
      </cube-checkbox>
      <div class="scroll-list-wrap" v-if="openLaw" style="padding: 10px, z-index: 1000;">
        <div style="width: 91%; padding: 20px; margin: 0px auto; overflow-y: auto; height: 400px;">
          <ul>
            <li>個人資料蒐集、處理、利用書面同意書</li>
            <li>為遵守個人資料保護法規定，並保障當事人之權利，謹依法告知下列事項：</li>
            <li>1.	品牌會員：{{info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand  + '&nbsp;' + 'Taiwan'}}</li>
            <!-- <li>The name of the Company:   Louisa coffee（the”Company”）</li> -->
            <li>2.	蒐集目的：為提供{{info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand}} Taiwan 社群會員卡專案用途。</li>
            <li>3.	個人資料之類別：姓名、電話、地址、生日或其他相關基本資料等。</li>
            <li>4.	個人資料利用之期間、地區、對象及方式：對於您提供之個人資料，將於執行社群會員卡專案用途期間，依個人資料保護法之相關規定使用您的個人資料，不另做其他用途。</li>
            <li>5.	依個人資料保護法第3條規定，當事人可行使以下權利：</li>
            <li>(1) 查詢或請求閱覽。<br>(2) 請求製給複製本。<br>(3) 請求補充或更正。<br>(4) 請求停止蒐集、處理及利用。<br>(5) 請求刪除。<br>若有上述需求，請與{{ info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand + '&nbsp;' + 'Taiwan'}} 連繫(聯絡資訊: cservice@mail.ruentex.com.tw)。另依個人資料保護法第14條規定，查詢或請求閱覽個人資料或製給複製本者，{{info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand + '&nbsp;' +  'Taiwan'}} 得酌收必要成本費用。</li>
            <!-- <li>According to article 3 of Personal Data Protection Act, you are entitled to exercise the following rights:</li>
            <li>(a) any inquiry and request for a review of the personal information;<br>(b) any request to make duplications of the personal information;<br>(c) any request to supplement or correct the personal information;<br>(d) any request to discontinue collection, processing or use of personal information;<br>(e) any request to delete the personal information<br>Please contact the Company if you have any requirement above mentioned ( contact information:  https
              ://www.louisacoffee.co/contact-info)。However, according to article 14 of Personal Data Protection Act, the company may charge the necessary fee to those who make an inquiry or request to review, or make duplications of the personal information.</li> -->
            <li>6.	您得自由選擇是否提供相關個人資料，惟您若拒絕提供或未提供正確個人資料，{{ info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand + '&nbsp;' +  'Taiwan'}} 將無法提供您蒐集目的範圍內之相關服務。</li>
            <li>本人已充分知悉上述告知事項，並同意貴公司基於上述蒐集目的蒐集、處理、利用本人之個人資料。</li>
            <!-- <li>I have fully read, understood and accepted the contents of this Agreement, and agree the Company to collect, process and use my personal information based on the collection purpose above mentioned.</li> -->
            <li>【請注意，此處點選提交，代表您已經閱畢「{{ info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand + '&nbsp;' +  'Taiwan'}}會員申請」之個資告知事項，並願以電子文件方式同意本公司蒐集、處理、以及利用您的個人資料，若您不同意「{{ info.brand === 'JEEP' ? 'JEEP®SPIRIT' : info.brand + '&nbsp;'  + 'Taiwan'}} 會員申請」蒐集、處理、以及利用您的個人資料，請關閉此頁面，此次申請將不會成功。】</li>
          </ul>
        </div>
        <!-- <cube-checkbox v-model="checked" position="center" shape="square" :hollow-style="true">
          我已閱讀並同意
        </cube-checkbox> -->
        <cube-button id="sign-in-button" class="item" :light="true"  style="transform: translateY(0px);" @click="closeTerms" >確認</cube-button>
      </div>
      <br>
      <!-- 確認按鈕 -->
      <cube-button  :disabled="checked !== true" id="sign-in-button" class="item" :light="true"  style="transform: translateY(0px);" @click="login" >確認</cube-button>

      <!-- 必填註冊內容 -->
      <div id="layer" v-if="requInfo">
        <div class="info" style="height: 320px;">
          <div class="list">
            <div class="item" style="text-align:center;">
              <div class="left"></div>
              <div class="middle" style="margin-left: 20px;">個人資訊</div>
              <div class="right"></div>
            </div>
          </div>
          <br>
          <cube-form :model="model" :immediate-validate="false">
            <cube-form-group>
              <cube-form-item style="border: 1px solid #eee; width: 80%; margin: 0 auto;" :field="fields[8]" title="請選擇"></cube-form-item>
              <br>
              <cube-form-item style="border: 1px solid #eee; width: 80%; margin: 0 auto;" :field="fields[9]" title="請選擇"></cube-form-item>
              <br>
            </cube-form-group>
          </cube-form>
          <br><br>
          <cube-button :primary="true" style="width: 89%; margin: 0 auto;" @click="insertMember" :outline="true">確認</cube-button>
        </div>
      </div>
      <!-- 非必填註冊內容 -->
      <div id="layer" v-if="noneInfo">
        <div class="info">
          <div class="list">
            <div class="item" style="text-align:center;">
              <div class="left"></div>
              <div class="middle" style="margin-left: 20px;">最後一步<i class="cubeic-close" style="position: absolute; right: 20px;" @click="closeDia"/></div>
              <div class="right"></div>
            </div>
          </div>
          <br>
          <cube-form :model="model" :immediate-validate="false">
            <cube-form-group>
              <cube-form-item style="border: 1px solid #eee; width: 80%; margin: 0 auto;" :field="fields[4]" title="請選擇"></cube-form-item>
              <br>
              <cube-form-item style="border: 1px solid #eee; width: 80%; margin: 0 auto;" :field="fields[5]" title="請選擇"></cube-form-item>
              <br>
              <cube-form-item style="border: 1px solid #eee; width: 80%; margin: 0 auto;" :field="fields[6]" title="請選擇"></cube-form-item>
              <br>
              <cube-form-item style="border: 1px solid #eee; width: 80%; margin: 0 auto;" :field="fields[7]" title="請選擇"></cube-form-item>
            </cube-form-group>
          </cube-form>
          <br><br>
          <cube-button :primary="true" style="width: 89%; margin: 0 auto;" :outline="true">確認</cube-button>
        </div>
      </div>

      <!-- Eilis LOGO -->
      <!-- <div class="bottom">
        <img src="../img/eilis.png" alt="Smiley face" height="14" width="">
        <div style="transform: scale(0.7)"> 智慧互動助理提供</div>
      </div> -->
      <cube-loading :size="35" class="loadingIcon" v-if="loading" ></cube-loading>
      <div id="layer" v-if="loading"/>
    </div>
    <!-- QR Code -->
    <!-- <div v-if="platform === 'desktop'">
      <div style="border: 1px solid #cbced3; display: inline-block; padding: 20px; padding-bottom: 12px; margin-top: 40px; width: 200px;">
        <qrcode-vue :value="qrcode" size="150" level="H"></qrcode-vue>
      </div>
      <div style="margin-top: 15px;">
        {{ $t('Login.no_service') }}<br>{{ $t('Login.scan_code') }}
      </div>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import counter from '@/components/data/counter.json'
import axios from 'axios'
/* eslint-disable */
const region = {
    '基隆市':['200仁愛區', '201信義區', '202中正區', '203中山區', '204安樂區', '205暖暖區', '206七堵區'],
    '台北市':["100中正區","103大同區","104中山區","106大安區","105松山區","108萬華區","110信義區","111士林區","112北投區","114內湖區","115南港區","116文山區"],
    '新北市':['234永和區',"220板橋區","234永和區","235中和區","221汐止區","236土城區","244林口區","252三芝區","251淡水區","249八里區","248五股區","247蘆洲區","242新莊區","243泰山區","237三峽區","253石門區","241三重區","239鶯歌區","238樹林區","231新店區","208金山區","207萬里區","233烏來區","232坪林區","222深坑區","223石碇區","224瑞芳區","226平溪區","227雙溪區","228貢寮區"],
    '宜蘭縣':['260宜蘭市', '261頭城鎮', '262礁溪鄉', '263壯圍鄉', '264員山鄉', '265羅東鎮', '266三星鄉', '267大同鄉', '268五結鄉', '269冬山鄉', '270蘇澳鎮', '272南澳鄉', '290釣魚台'],
    '桃園市':['320中壢區', '324平鎮區', '325龍潭區', '326楊梅區', '327新屋區', '328觀音區', '330桃園區', '333龜山區', '334八德區', '335大溪區', '336復興區', '337大園區', '338蘆竹區'],
    '新竹市':['300東區', '300北區', '300香山'],
    '新竹縣':['308寶山鄉','302竹北市', '303湖口鄉', '304新豐鄉', '305新埔鎮', '306關西鎮', '307芎林鄉', '310竹東鎮', '311五峰鄉', '312橫山鄉', '313尖石鄉', '314北埔鄉', '315峨眉鄉'],
    '苗栗縣':['350竹南鎮', '351頭份鎮', '352三灣鄉', '353南庄鄉', '354獅潭鄉', '356後龍鎮', '357通霄鎮', '358苑裡鎮', '360苗栗市', '361造橋鄉', '362頭屋鄉', '363公館鄉', '364大湖鄉', '365泰安鄉', '366銅鑼鄉', '367三義鄉', '368西湖鄉', '369卓蘭鎮'],
    '台中市':['400中區', '401東區', '402南區', '403西區', '404北區', '406北屯區', '407西屯區', '408南屯區', '411太平區', '412大里區', '413霧峰區', '414烏日區', '420豐原區', '421后里區', '422石岡區', '423東勢區', '424和平區', '426新社區', '427潭子區', '428大雅區', '429神岡區', '432大肚區', '433沙鹿區', '434龍井區', '435梧棲區', '436清水區', '437大甲區', '438外埔區', '439大安區'],
    '彰化縣':['500彰化市', '502芬園鄉', '503花壇鄉', '504秀水鄉', '505鹿港鎮', '506福興鄉', '507線西鄉', '508和美鎮', '509伸港鄉', '510員林鎮', '511社頭鄉', '512永靖鄉', '513埔心鄉', '514溪湖鎮', '515大村鄉', '516埔鹽鄉', '520田中鎮', '521北斗鎮', '522田尾鄉', '523埤頭鄉', '524溪州鄉', '525竹塘鄉', '526二林鎮', '527大城鄉', '528芳苑鄉', '530二水鄉'],
    '南投縣':["540南投市","541中寮鄉","542草屯鎮","544國姓鄉","545埔里鎮","546仁愛鄉","551名間鄉","552集集鎮","553水里鄉","555魚池鄉","556信義鄉","557竹山鎮","558鹿谷鄉"],
    '雲林縣':["630斗南鎮","631大埤鄉","632虎尾鎮","633土庫鎮","634褒忠鄉","635東勢鄉","636台西鄉","637崙背鄉","638麥寮鄉","640斗六市","643林內鄉","646古坑鄉","647莿桐鄉","648西螺鎮","649二崙鄉","651北港鎮","652水林鄉","653口湖鄉","654四湖鄉","655元長鄉"],
    '嘉義市':['600西區', '600東區'],
    '嘉義縣':['602番路鄉', '603梅山鄉', '604竹崎鄉', '605阿里山鄉', '606中埔鄉', '607大埔鄉', '608水上鄉', '611鹿草鄉', '612太保市', '613朴子市', '614東石鄉', '615六腳鄉', '616新港鄉', '621民雄鄉', '622大林鎮', '623溪口鄉', '624義竹鄉', '625布袋鎮'],
    '台南市':["704北區", "701東區", "702南區", "700中西區", "710永康區","711歸仁區","712新化區","713左鎮區","714玉井區","715楠西區","716南化區","717仁德區","718關廟區","719龍崎區","720官田區","721麻豆區","722佳里區","723西港區","724七股區","725將軍區","726學甲區","727北門區","730新營區","731後壁區","732白河區","733東山區","734六甲區","735下營區","736柳營區","737鹽水區","741善化區","742大內區","743山上區","744新市區","745安定區", "708安平區", "709安南區"],
    '高雄市':['800新興區', '801前金區', '802苓雅區', '803鹽埕區', '804鼓山區', '805旗津區', '806前鎮區', '807三民區', '811楠梓區', '812小港區', '813左營區', '814仁武區', '815大社區', '820岡山區', '821路竹區', '822阿蓮區', '823田寮區', '824燕巢區', '825橋頭區', '826梓官區', '827彌陀區', '828永安區', '829湖內區', '830鳳山區', '831大寮區', '832林園區', '833鳥松區', '840大樹區', '842旗山區', '843美濃區', '844六龜區', '845內門區', '846杉林區', '847甲仙區', '848桃源區', '849那瑪夏區', '851茂林區', '852茄萣區'],
    '屏東縣':['900屏東市', '901三地門鄉', '902霧台鄉', '903瑪家鄉', '904九如鄉', '905里港鄉', '906高樹鄉', '907鹽埔鄉', '908長治鄉', '909麟洛鄉', '911竹田鄉', '912內埔鄉', '913萬丹鄉', '920潮州鎮', '921泰武鄉', '922來義鄉', '923萬巒鄉', '924崁頂鄉', '925新埤鄉', '926南州鄉', '927林邊鄉', '928東港鎮', '929琉球鄉', '931佳冬鄉', '932新園鄉', '940枋寮鄉', '941枋山鄉', '942春日鄉', '943獅子鄉', '944車城鄉', '945牡丹鄉', '946恆春鎮', '946滿州鄉'],
    '台東縣':['950台東市','951綠島鄉', '952蘭嶼鄉', '953延平鄉', '954卑南鄉', '955鹿野鄉', '956關山鎮', '957海端鄉', '958池上鄉', '959東河鄉', '961成功鎮', '962長濱鄉', '963太麻里鄉', '964金峰鄉', '965大武鄉', '966達仁鄉'],
    '花蓮縣':['970花蓮市', '971新城鄉', '972秀林鄉', '973吉安鄉', '974壽豐鄉', '975鳳林鎮', '976光復鄉', '977豐濱鄉', '978瑞穗鄉', '979萬榮鄉', '981玉里鎮', '982卓溪鄉', '983富里鄉'],
    '金門縣':['890金沙鎮', '891金湖鎮', '892金寧鄉', '893金城鎮', '894烈嶼鄉', '895烏坵鄉'],
    '連江縣':['南竿鄉', '210北竿鄉', '211莒光鄉', '212東引鄉'],
    '澎湖縣':['880馬公市', '881西嶼鄉', '882望安鄉', '883七美鄉', '884白沙鄉', '885湖西鄉']
}
const years = ['1920','1921','1922','1923','1924','1925','1926','1927','1928','1929',
              '1930','1931','1932','1933','1934','1935','1936','1937','1938','1939',
              '1940','1941','1942','1943','1944','1945','1946','1947','1948','1949',
              '1950','1951','1952','1953','1954','1955','1956','1957','1958','1959',
              '1960','1961','1962','1963','1964','1965','1966','1967','1968','1969',
              '1970','1971','1972','1973','1974','1975','1976','1977','1978','1979',
              '1980','1981','1982','1983','1984','1985','1986','1987','1988','1989',
              '1990','1991','1992','1993','1994','1995','1996','1997','1998','1999',
              '2000','2001','2002','2003','2004','2005','2006','2007','2008','2009',
              '2010','2011','2012','2013','2014','2015','2016','2017','2018','2019',]
export default {
  data () {
    return {
      requInfo: false,
      noneInfo: false,
      saleRoom: '',
      // brand: this.$route.query.brand ? this.$route.query.brand : localStorage.getItem('brand'),
      model: {
        name: '',
        year: '',
        month: '',
        day: '',
        selectValue: '選擇縣市',
        county: '',
        district: '',
        email: '',
        gender: '',
        saleroom: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'name',
          label: '姓名',
          props: {
            placeholder: '請輸入姓名',
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'year',
          label: '年份',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇出生年份',
            options: years.reverse(),
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'month',
          label: '月份',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇出生月份',
            disabled: true,
            options: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
          },
          rules: {
            required: true
          },
        },
        {
          type: 'select',
          modelKey: 'day',
          label: '日期',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇出生日期',
            disabled: true,
            options: [],
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'county',
          label: '縣市',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇縣市',
            options: Object.keys(region),
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'district',
          label: '區域',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇鄉鎮區域',
            options: [],
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'name',
          label: '地址',
          props: {
            placeholder: '請輸入地址',
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'email',
          label: 'Email',
          props: {
            placeholder: '請輸入Email',
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'gender',
          label: '性別',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請輸入性別',
            options: ['男','女'],
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'saleroom',
          label: '櫃位',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請輸入',
            // options: counter.filter(el => el.counter === localStorage.getItem('brand'))[0].items.map(el => el.name),
            options: [],
          },
          rules: {
            required: true
          }
        },
        // {
        //   type: 'input',
        //   modelKey: 'saleroom',
        //   label: '櫃位',
        //   props: {
        //     placeholder: '請輸入櫃位',
        //   },
        //   rules: {
        //     required: true
        //   }
        // },
      ],
      counterList: [],
      openLaw: false,
      checked: false,
      // day: '',
      loading: true,
      name: '',
      phoneVerify: false,
      PhoneNumber: this.$route.query.phone,
      loading: false,
      option: Object.keys(region),
      verifyId: '',
      verCode: '',
      Service: this.$route.params.service,
      visibility: false,
      alert: false,
      alertmessage: '電話號碼還未輸入喔！',
      countryCode: '+886',
      channelData: {
        AuthToken: this.$route.query.Auth,
        Service: this.$route.params.service,
        PhoneNumber: '',
        Name: this.$route.query.Name ? this.$route.query.Name : '',
        PageID: this.$route.query.Page,
        trigger: this.$route.query.trigger,
        transactionId: this.$route.query.transactionId,
        Img: this.$route.query.Img,
      },
      countries:[
        {
          text: 'Taiwan',
          value: '+886',
          example: '0912345678'
        },
        {
          text: 'Cambodia' ,
          value: '+855',
          example: '091234567'
        },
        {
          text: 'Malaysia',
          value: '+60',
          example: '0123456789'
        }
      ],
    }
  },
  watch: {
    saleroomSelect(val) {
      // console.log(val);
      // console.log(counter.filter(el => el.counter === this.brand)[0].items.filter(el => el.name === val)[0].id);
      if (val !== '') {
        // const saleroom = counter.filter(el => el.counter === this.brand)[0].items.filter(el => el.name === val)[0].id;
        const saleroom = this.counterList.filter(el => el.name === val).map(el => el.no)[0]
        // console.log(saleroom);
        this.saleRoom = saleroom;
        // this.model.saleroom = room
        // console.log(this.model.saleroom);
      }
    },
    countySelect(val) {
      // console.log(val);
      this.fields[5].props.options = region[this.model.county];
      // console.log(region[this.model.county]);
    },
    selectYear(val) {
      this.model.month = '';
      if (val) {
        this.fields[2].props.disabled = false;
      }
      else {
        this.fields[2].props.disabled = true;
      }
    },
    selectMonth(val) {
      this.model.day = '';
      if (val) {
        this.fields[3].props.disabled = false;
        const monthNum = (val[0] === '0') ? parseInt(val[1]) : parseInt(val);
        let dayList = [];
        const monthDay = new Date(this.selectYear, val, 0).getDate();
        for (let i = 0; i < monthDay; i += 1) {
          const day = (i + 1) < 10 ? `0${i + 1}` : (i + 1).toString();
          dayList.push(day);
        }
        this.fields[3].props.options = dayList;
      }
      else {
        this.fields[3].props.disabled = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      info: 'info',
      brandCode: 'brandCode',
      ruentexProfile: 'ruentexProfile',
      eilisProfile: 'eilisProfile',
    }),
    saleroomSelect() {
      return this.model.saleroom;
    },
    countySelect() {
      return this.model.county;
    },
    transform() {
      // watch 無法監聽物件, computed不能修改component的值, 所以顯示會用placeholder
      if (this.channelData.Service === 'LINE') {
        return this.channelData.AuthToken.substr(5,10);
      } else {
        return this.channelData.AuthToken
      }
    },
    ruFile: {
      get () { return this.ruentexProfile },
      set(value) { this.storeRuenFile({ Profile: value }); },
    },
    EFile: {
      get () { return this.eilisProfile },
      set(value) { this.storeEilisFile({ Efile: value }); },
    },
    token: {
      get () { return this.info.token },
      set(value) { this.updatetoken({ price: value }); },
    },
    phone: {
      get () { return this.info.phone },
      set(value) { this.updatephone({ phone: value }); },
    },
    // name: {
    //   get () { return this.info.name },
    //   set(value) { this.updatename({ name: value }); },
    // },
    // birth: {
    //   get () { return this.info.birth },
    //   set(value) { this.updatebirth({ birth: value }); },
    // },
    options() {
      if (this.county) {
        return region[this.county];
      }
      return [];
    },
    selectRoom() {
      return counterList;
    },
    selectYear() {
      return this.model.year;
    },
    selectMonth() {
      return this.model.month;
    },
  },
  mounted() {
    // console.log(counter);
    // console.log(this.info.clientId);
    // this.requInfo = true;
    this.getStoreList({clientId: this.info.clientId})
    .then((res) => {
      // console.log(res);
      // console.log(res.data.result.filter(el => el.no !== '無'));
      this.fields[9].props.options = res.data.result.filter(el => el.no !== '無').map(el => el.name)
      this.counterList = res.data.result.filter(el => el.no !== '無')
      // console.log(this.fields[9].props.options);
    })
    // console.log(counter.filter(el => el.counter === this.brand)[0].items.map(el => el.name));
    // this.loading = true;
    // console.log(this.info);
    // console.log(this.info.birth);
    if (this.info.name) {
      this.model.name = this.info.name;
      this.model.year = this.info.birth;
    } else if (this.PhoneNumber) {
      this.phone = this.PhoneNumber;
      // console.log(this.phone);
    }

  },
  methods: {
    ...mapMutations({
      updatephone: 'updatephone',
      storeRuenFile: 'storeRuenFile',
      storeEilisFile: 'storeEilisFile',
    }),
    ...mapActions({
      readMember: 'readMember',
      registerEilis: 'registerEilis',
      addMember: 'addMember',
      updateMember: 'updateMember',
      updateMemberEilis: 'updateMemberEilis',
      getStoreList: 'getStoreList'
    }),
    insertMember() {
      // console.log(this.saleRoom);
      // return;
      this.loading = true;
      // console.log(this.model.gender);
      // console.log(this.model.saleroom);
      if (this.model.gender === '') {
        const contents = '性別欄位未填'
        this.showAlert(contents);
        this.loading = false;
        return;
      } else if (this.model.saleroom === '') {
        const contents = '櫃位欄位未填'
        this.showAlert(contents);
        this.loading = false;
        return;
      }
        // this.model.saleroom 轉成 this.saleRoom
        this.addMember({
          gender: this.model.gender,
          saleroom: this.saleRoom,
          phone: this.info.phone,
          birth: this.model.year + this.model.month + this.model.day,
          brand: this.brandCode,
          name: this.model.name,
          lineid: this.channelData.Service === 'LINE' ? this.channelData.AuthToken : null,
          // fbid: this.channelData.Service === 'LINE' ? null : this.channelData.AuthToken,
          })
        .then((res) => {
          // console.log(res);
          const memberClass = res.data.result.cardkind;
          if (res.data.status === 200) {
            this.registerEilis({
              service: this.channelData.Service,
              clientId: this.info.clientId,
              token: this.channelData.AuthToken,
              phone:  this.info.phone,
              userId: res.data.result,
              name: this.model.name,
              birth: this.model.year + this.model.month + this.model.day,
              profileImg: this.channelData.Img ? this.channelData.Img : '',})
            .then((res) => {
              // console.log(res);
              if (res.data.status === '10020') {
                const saleRoom = {
                  saleroom: this.saleRoom,
                  cardkind: memberClass,
                }
                // console.log(saleRoom);
                this.updateMemberEilis({clientId: this.info.clientId,phone: this.info.phone, gender: this.model.gender, detail: saleRoom,})
                .then(() => {
                  this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&brand=${this.$route.query.brand}`);
                })
              } else {
                const contents = '發生錯誤，請重新選擇'
                this.showAlert(contents);
                this.loading = false;
              }
            })
          } else {
            const contents = res.data.result
            this.showAlert(contents);
            this.loading = false;
          }
        })
        .catch((err) => {
          // console.log(err);
          const contents =
          this.showAlert(contents);
          this.loading = false;
        })
    },
    closeDia() {
      this.noneInfo = false;
    },
    closeTerms() {
      this.openLaw = false;
    },
    openTerms() {
      this.openLaw = true;
    },
    showAlert(contents) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: contents,
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
    },
    showAlert_script() {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: '僅允許中英文或空格',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
    },
    login(val) {
      this.loading = true;
      // return;
      // 取100-500之間,
      const time = Math.floor(Math.random()* (500-100+1))+100
      // 空格：/^\w+(?:\s+\w+)*$/
      var txt = new RegExp(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5/^\w+(?:\s+\w+)*$/]/g,);
      var Chi = new RegExp(/[\u4e00-\u9fa5]{10}/); // 中文限制10個字
      var Eng = new RegExp(/[a-zA-Z]\w{20}/); // 英文限制3-20個字
      if (txt.test(this.model.name)) {
        this.showAlert_script();
        this.loading = false;
        return;
      }
      else if (Chi.test(this.model.name)) {
        const contents = '姓名不能填寫超過10個中文字'
        this.showAlert(contents);
        this.loading = false;
        return;
      } else if (Eng.test(this.model.name)) {
        const contents = '姓名不能填寫超過20個英文字'
        this.showAlert(contents);
        this.loading = false;
        return;
      }
      if (this.model.name === '') {
        const contents = '姓名還未填'
        this.showAlert(contents);
        this.loading = false;
        return;
      } else if (this.model.year === '' || this.model.month === '' || this.model.day === '') {
        const contents = '生日忘記填喔！'
        this.showAlert(contents);
        this.loading = false;
        return;
      } else if (this.info.phone === '') {
        const contents = '遺失電話，請重新註冊！'
        this.showAlert(contents);
        this.loading = false;
        return;
      } else {
        this.readMember({ phone: this.info.phone , birth: this.model.year + this.model.month + this.model.day , brand: this.brandCode,})
        .then((res) => {
          // console.log(res);
          const gender = res.data.result.gender
          const address = res.data.result.address
          const email = res.data.result.email
          const custid = res.data.result.custid
          const name = res.data.result.name
          const birth = res.data.result.birth
          const memberClass = res.data.result.cardkind;
          const saleroom = res.data.result.saleroom
          const cardkind = {
            cardkind: memberClass,
            saleroom: saleroom
          }
          if (res.data.status === 300) {
            // 300 = 多筆資料
            // 超過ㄧ筆資料的條件下
            const contents = '為了維護您的會員權益請至店櫃完成升等'
            this.showAlert(contents);
            this.loading = false;
            const url = 'https://script.google.com/macros/s/AKfycbxTrRxfdE3ZqhCVx3E6l2m0S7Zi-KHKgTHGiREY3vNy2KvNVQA/exec';
            const time = new Date(Date.now()).toLocaleString();
            let brand = this.brandCode;
            let name = this.model.name;
            let phone = this.info.phone;
            let birth = this.model.year + this.model.month + this.model.day;
            let Id = this.channelData.AuthToken;
            let oldId = ''
            const data = {
              time,
              name,
              phone,
              birth,
              Id,
              oldId,
              brand
            }
            axios.get(url, {params: data})
            .then((res) => {
              // console.log(res);
            })
          } else if (JSON.parse(res.data.status) === 200) {
            // 只有ㄧ筆資料的條件下
            // console.log('626');
            // console.log(res.data.result.custid);
            // console.log(this.info.phone);
            this.registerEilis({
              service: this.channelData.Service,
              clientId: this.info.clientId,
              token: this.channelData.AuthToken,
              phone:  this.info.phone,
              userId: custid,
              name: this.model.name,
              birth: this.model.year + this.model.month + this.model.day,
              profileImg: this.channelData.Img ? this.channelData.Img : '',
              })
              .then((res) => {
                this.updateMemberEilis({clientId: this.info.clientId,phone: this.info.phone, gender: gender, detail: cardkind, address: address, email: email})
                .then(() => {
                  // this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}`);
                  this.updateMember({
                    brand: this.brandCode,
                    custid: custid,
                    name: this.model.name,
                    phone: this.info.phone,
                    lineid: this.channelData.Service === 'LINE' ? this.channelData.AuthToken : null,
                    fbid: this.channelData.Service === 'LINE' ? null : this.channelData.AuthToken ,
                  })
                  .then((res) => {
                    this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}&brand=${this.$route.query.brand}`);
                  })
                })
              })
          } else {
            // 204 查無資料
            this.requInfo = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  li {
    font-size: 13px;
    line-height: 25px;
    word-break: break-all;
  }
  .scroll-list-wrap {
    z-index: 10000;
    text-align: left;
    background-color: #ffffff;
    word-break: break-all;
    margin-top: -450px;
    height: 1000px;
    font-size: 0.5cm;
    transform: rotate(0deg); // fix 子元素超出边框圆角部分不隐藏的问题
    overflow: hidden;
    // transform: scale();
  }
  .mobile-wrap {
    margin: auto;
    width: 300px;
    height: 1200px;
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .mobile-wrap:before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    position: absolute;
    // background: rgba(90, 93, 165, .8);
    // background: linear-gradient(to bottom, rgba(90, 93, 165, 1), rgba(0, 0, 0, .7))
  }
  .loadingIcon {
    z-index: 100;
    position: relative;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    // z-index: 1000000;
    margin: 0 auto;
    text-align: center;
    margin-top: -450px;
    width: 55px;
    height: 55px;
    color: #ffffff;
    border-radius: 5px;
    background-color: #717171;
    // -webkit-text-fill-color: transparent;
  }
  #layer{
    z-index: 20;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(159, 159, 159, 0.527);
    overflow-y: hidden !important;
  }
  .info {
    // border: 1px solid rgb(211, 211, 211);
    border-radius: 0px;
    z-index: 1000;
    width: 80%;
    margin: 0 auto;
    z-index: 10000;
    text-align: left;
    background-color: #ffffff;
    margin-top: 130px;
    height: 420px;
    font-size: 0.5cm;
    border-radius: 3px;
    overflow-y: auto;
    // transform:translate(-50%,-50%);
    animation: bomaction 0.15s linear forwards;
    // transform: rotate(0deg); // fix 子元素超出边框圆角部分不隐藏的问题
  }
  @keyframes bomaction {
    0% {
      -webkit-transform: scale(0.1)  rotate(0deg);
              transform: scale(0.1)  rotate(0deg);
      top:0%;
    }
    46% {
      top:52%;
    }
    48% {
      top:48%;
    }
    50% {
      -webkit-transform: scale(0.5)  rotate(0deg);
              transform: scale(0.5)  rotate(0deg);
      top:52%;
    }
    54% {
      top:52%;
    }
    56% {
      top:48%;
    }
    57% {
      -webkit-transform: scale(0.9)  rotate(0deg);
              transform: scale(0.9)  rotate(0deg);
      top:48%;
    }
    75% {
      -webkit-transform: scale(0.95)  rotate(0deg);
              transform: scale(0.95)  rotate(0deg);
      top:48%;
    }
    90% {
      -webkit-transform: scale(1.15)  rotate(0deg);
              transform: scale(1.15)  rotate(0deg);
      top:48%;
    }
    100% {
      -webkit-transform: scale(1) translateX(0px) rotate(0deg);
              transform: scale(1) translateX(0px) rotate(0deg);
      top:50%;
    }
  }
  .menu {
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    min-width: 300px;
    height: 750px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .pic {
    position: relative;
    z-index: 1;
    transform: scale(0.7);
    top: 15px;
    margin: 0px;
    margin-left: 0px;
    height: 150px;
  }
  .item {
    // z-index: 1;
    width: 80%;
    max-width: 420px;
    min-width: 200px;
    margin: 0 auto;
    margin-top: 20px;
  }
  section {
    position: relative;
    background-color: none;
    width: 100%;
    height: 100vh;
  }
  #curve {
    z-index: 1000;
    position: relative;
    transform: scale(4) rotate(6deg);
    bottom: 500px;
    left: 200px;
    width: 100%;
  }
  #curve path {
    fill: rgb(76, 182, 14);
  }
  .bottom {
    font-size: 5px;
    position: relative;
    margin-top: 30px;
  }
</style>
